import { axiosAPIInstance as axios } from '../../axios-config';

const actions = {
  async createArticle(_, article) {
    const response = await axios.post('/blade/articles', article);
    return response.data.article;
  },
  async getArticles() {
    const response = await axios.get('/blade/articles');
    return response.data.articles;
  },
  async getArticle(_, { articleId }) {
    const { data } = await axios.get(`/blade/articles/${articleId}`);
    return data;
  },
  async getArticleTypes() {
    const { data } = await axios.get('/blade/articles/types');
    return data;
  },
  async updateArticle(_, article) {
    const response = await axios.patch(`/blade/articles/${article._id}`, article);
    return response.data.article;
  },
  async deleteArticle(_, { articleId, _id }) {
    const did = articleId || _id;
    const response = await axios.delete(`/blade/articles/${did}`);
    return response.data.article;
  },
  // public facing for end users to read support articles
  async getCategoryContent(_, { articleCategoryId }) {
    const response = await axios.get(`/blade/category-content/${articleCategoryId}`);
    return response.data; // { articleCategories, articles }
  },
  async getArticleContent(_, { articleId }) {
    const { data } = await axios.get(`/blade/article/${articleId}`);
    return data.article;
  },
  async searchArticles(_, { searchInput }) {
    const { data } = await axios.get(`/blade/search-articles?searchInput=${encodeURIComponent(searchInput)}`);
    return data.articles;
  },
};

export default {
  actions
};



// WEBPACK FOOTER //
// ./src/store/blade/articles.js